module.exports = __webpack_public_path__ + "images/stickers/taco-angry@2x.3f00295259b22aa6c6a0.png";